export function init(){
  var mobile_toggle = document.getElementById('mobile_toggle');
  if (mobile_toggle){
    mobile_toggle.addEventListener('click', navToggle)
  }
}

function navToggle(){
  document.body.classList.toggle('nav_open');
}